(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('.wk-rail2').forEach(enhanceRail);
    var mount = scope.querySelector('[data-wk-catalog]');
    if (mount && !mount.dataset.ready) initCatalog(mount);
  }
  function enhanceRail(section) {
    if (section.dataset.shoppingReady) return;
    var strip = section.querySelector('.strip');
    if (!strip) return;
    section.dataset.shoppingReady = '1';
    strip.tabIndex = 0;
    strip.setAttribute('role', 'region');
    var heading = section.querySelector('h2');
    strip.setAttribute('aria-label', heading ? heading.textContent.trim() : 'Products');
    var left = section.querySelector('.nav.l'), right = section.querySelector('.nav.r');
    function update() {
      var maximum = strip.scrollWidth - strip.clientWidth;
      if (left) left.disabled = strip.scrollLeft <= 8;
      if (right) right.disabled = strip.scrollLeft >= maximum - 2;
      section.classList.toggle('wk-no-overflow', maximum < 3);
    }
    function move(direction) {
      var card = strip.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(strip).gap) || 16) : strip.clientWidth;
      var count = Math.max(1, Math.floor(strip.clientWidth / step));
      strip.scrollBy({left: direction * step * count, behavior: 'instant'});
    }
    section.addEventListener('click', function (event) {
      var button = event.target.closest('.nav');
      if (!button || !section.contains(button)) return;
      event.stopImmediatePropagation();
      move(button.classList.contains('l') ? -1 : 1);
    }, true);
    strip.addEventListener('keydown', function (event) {
      if (event.target !== strip) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault(); strip.scrollTo({left: event.key === 'Home' ? 0 : strip.scrollWidth});
      }
    });
    var start = null, dragged = false;
    strip.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      start = {x: event.clientX, scroll: strip.scrollLeft, id: event.pointerId}; dragged = false;
    });
    strip.addEventListener('pointermove', function (event) {
      if (!start) return;
      var distance = event.clientX - start.x;
      if (!dragged && Math.abs(distance) < 8) return;
      if (!dragged) { dragged = true; strip.setPointerCapture(start.id); strip.classList.add('wk-dragging'); }
      strip.scrollLeft = start.scroll - distance; event.preventDefault();
    });
    function end() { start = null; strip.classList.remove('wk-dragging'); }
    strip.addEventListener('pointerup', end);
    strip.addEventListener('pointercancel', end);
    strip.addEventListener('lostpointercapture', end);
    strip.addEventListener('pointerleave', function () { if (!dragged) start = null; });
    strip.addEventListener('click', function (event) { if (dragged) { event.preventDefault(); event.stopImmediatePropagation(); dragged = false; } }, true);
    strip.addEventListener('dragstart', function (event) { event.preventDefault(); });
    strip.addEventListener('scroll', update, {passive: true});
    new MutationObserver(update).observe(strip, {childList: true});
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(strip);
    update();
  }
  function category(product) {
    var title = (product.t + ' ' + product.type).toLowerCase();
    if (/bikini|swim|bra top|thong|underwear/.test(title)) return 'swim';
    if (/hoodie|hooded|sweatshirt|jacket|outerwear|sweater|zip.up/.test(title)) return 'layers';
    if (/pants|shorts|jogger|legging/.test(title)) return 'bottoms';
    if (/\btee\b|t.shirt|shirt|crop|tank top|jersey/.test(title)) return 'tops';
    if (/skateboard|longboard|griptape|grip tape|deck series/.test(title)) return 'skate';
    if (/blanket|tapestry|tapestries|rug|pillow|decor|canvas|poster|night light|snow globe|mug/.test(title)) return 'home';
    if (/\bcd\b|vinyl|digital track/.test(title)) return 'music';
    if (/hat|beanie|cap\b|bag|backpack|case|jewelry|necklace|sticker|bandana|sock|slide|shoe|keychain|mouse pad|desk mat/.test(title)) return 'accessories';
    return 'other';
  }
  function normalize(p) {
    var variants = p.variants || [], prices = variants.map(function (v) { return Math.round(Number(v.price) * 100); });
    var minimum = prices.length ? Math.min.apply(null, prices) : 0;
    var minimumVariant = variants[prices.indexOf(minimum)] || {};
    return {h: p.handle, t: p.title || '', type: p.product_type || '', price: minimum,
      compare: Math.round(Number(minimumVariant.compare_at_price || 0) * 100), varies: prices.some(function (n) { return n !== minimum; }),
      avail: variants.some(function (v) { return v.available; }), created: p.created_at || '',
      img: p.images && p.images[0] ? p.images[0].src : '', tags: Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '')};
  }
  function escape(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function initCatalog(mount) {
    mount.dataset.ready = '1';
    var seed = JSON.parse(mount.querySelector('[data-catalog-seed]').textContent);
    var labels = seed.labels, root = seed.root, grid = mount.querySelector('[data-catalog-grid]');
    var status = mount.querySelector('[data-catalog-status]'), more = mount.querySelector('[data-catalog-more]');
    var empty = mount.querySelector('[data-catalog-empty]'), retry = mount.querySelector('[data-catalog-retry]');
    var controls = mount.querySelector('[data-catalog-controls]'), reset = mount.querySelector('[data-catalog-reset]');
    var panel = mount.querySelector('[data-catalog-panel]');
    if (panel) {
      var mobileLayout = matchMedia('(max-width: 749px)');
      function sizePanel() { panel.open = !mobileLayout.matches; }
      sizePanel();
      if (mobileLayout.addEventListener) mobileLayout.addEventListener('change', sizePanel);
    }
    var products = new Map(seed.products.map(function (p) { return [p.h, p]; }));
    var seasonal = new Set(seed.seasonal || []), done = false, failed = false, loading = false, shown = 24, state;
    var cacheKey = 'wkCatalog3:' + root + ':' + seed.locale + ':' + seed.currency;
    function restoreCache() {
      try {
        var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (!cached || typeof cached.time !== 'number' || Date.now() - cached.time < 0 || Date.now() - cached.time >= 120000 || !Array.isArray(cached.products) || !cached.products.length) return false;
        if (!cached.products.every(function (p) { return p && typeof p.h === 'string' && typeof p.t === 'string' && typeof p.price === 'number'; })) return false;
        cached.products.forEach(function (p) { if (!products.has(p.h)) products.set(p.h, p); });
        return true;
      } catch (error) { return false; }
    }
    function saveCache() {
      try { sessionStorage.setItem(cacheKey, JSON.stringify({time: Date.now(), products: Array.from(products.values())})); } catch (error) { return; }
    }
    var money = new Intl.NumberFormat(seed.locale || 'en', {style: 'currency', currency: seed.currency});
    function readState() {
      var params = new URLSearchParams(location.search);
      state = {q: params.get('q') || '', category: params.get('category') || '', edit: params.get('edit') || '', stock: params.get('stock') || '', sort: params.get('sort') || 'new'};
      ['category','edit','stock','sort'].forEach(function (key) { var input = controls.elements.namedItem(key); if (!Array.from(input.options).some(function (o) { return o.value === state[key]; })) state[key] = key === 'sort' ? 'new' : ''; });
      Object.keys(state).forEach(function (key) { controls.elements.namedItem(key).value = state[key]; });
    }
    function writeState() {
      var url = new URL(location.href);
      Object.keys(state).forEach(function (key) { if (state[key] && !(key === 'sort' && state[key] === 'new')) url.searchParams.set(key, state[key]); else url.searchParams.delete(key); });
      try { history.replaceState(null, '', url); } catch (error) { return; }
    }
    function view() {
      var words = state.q.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      var result = Array.from(products.values()).filter(function (p) {
        if (/insurance|shipping protection|digital track/i.test(p.type + ' ' + p.t)) return false;
        var group = category(p), title = p.t.toLowerCase();
        if (state.category && group !== state.category) return false;
        if (state.stock === 'in' && !p.avail) return false;
        if (state.edit) {
          if (!seasonal.has(p.h)) return false;
          if (state.edit === 'fall' && !/hoodie|pants|sweatshirt|jacket/.test(title)) return false;
          if (state.edit === 'sigil' && !/sigil/.test(title)) return false;
          if (state.edit === 'xray' && !/x[ -]?ray|skelet|rib cage/.test(title)) return false;
          if (state.edit === 'camo' && (!/camo/.test(title) || /hoodie|pants/.test(title))) return false;
        }
        var text = (p.t + ' ' + p.type + ' ' + p.tags).toLocaleLowerCase();
        return words.every(function (word) { return text.indexOf(word) !== -1; });
      });
      result.sort(function (a, b) {
        if (state.sort === 'price-ascending') return a.price - b.price;
        if (state.sort === 'price-descending') return b.price - a.price;
        if (state.sort === 'title-ascending') return a.t.localeCompare(b.t);
        return (Date.parse(b.created) || 0) - (Date.parse(a.created) || 0);
      });
      return result;
    }
    function card(p, index) {
      var image = p.img ? p.img + (p.img.indexOf('?') < 0 ? '?' : '&') + 'width=600' : '';
      var sale = p.compare > p.price;
      return '<a class="wk-sa-card" href="' + root + 'products/' + escape(p.h) + '"><span class="ph">' +
        (!p.avail ? '<span class="wk-sa-badge out">' + escape(labels.sold_out) + '</span>' : sale ? '<span class="wk-sa-badge sale">' + escape(labels.sale) + '</span>' : '') +
        (image ? '<img class="a" src="' + escape(image) + '" alt="' + escape(p.t) + '" width="600" height="600" loading="' + (index < 4 ? 'eager' : 'lazy') + '" decoding="async">' : '<span class="wk-sa-placeholder">' + escape(labels.image_pending) + '</span>') +
        '</span><span class="ti">' + escape(p.t) + '</span><span class="pr">' + (p.varies ? escape(labels.from) + ' ' : '') + escape(money.format(p.price / 100)) +
        (sale ? ' <s>' + escape(money.format(p.compare / 100)) + '</s>' : '') + '</span></a>';
    }
    function render() {
      var list = view();
      grid.innerHTML = list.slice(0, shown).map(card).join('');
      status.textContent = list.length + ' ' + labels.products + (failed ? ' · ' + labels.partial : done ? '' : ' · ' + labels.loading);
      empty.hidden = list.length > 0 || !done;
      more.hidden = shown >= list.length;
      more.textContent = labels.load_more + ' (' + Math.min(24, Math.max(0, list.length - shown)) + ')';
      retry.hidden = !failed;
      reset.hidden = !state.q && !state.category && !state.edit && !state.stock && state.sort === 'new';
      mount.setAttribute('aria-busy', loading ? 'true' : 'false');
      mount.querySelectorAll('[data-edit-link]').forEach(function (link) { var on = link.dataset.editLink === state.edit; if (on) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
    }
    var timer;
    controls.addEventListener('submit', function (event) { event.preventDefault(); });
    controls.addEventListener('input', function (event) {
      if (event.target.name !== 'q') return;
      clearTimeout(timer); timer = setTimeout(function () { state.q = event.target.value; shown = 24; writeState(); render(); }, 180);
    });
    controls.addEventListener('change', function (event) {
      if (event.target.name === 'q') return;
      state[event.target.name] = event.target.value; shown = 24; writeState(); render();
    });
    function clear() { clearTimeout(timer); state = {q:'', category:'', edit:'', stock:'', sort:'new'}; shown = 24; writeState(); readState(); render(); }
    reset.addEventListener('click', clear);
    empty.querySelector('button').addEventListener('click', clear);
    more.addEventListener('click', function () { var previous = grid.children.length; shown += 24; render(); var next = grid.children[previous]; if (next) next.focus({preventScroll:true}); });
    mount.querySelectorAll('[data-edit-link]').forEach(function (link) { link.addEventListener('click', function (event) { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); clearTimeout(timer); state.edit = link.dataset.editLink; state.category = ''; state.q = ''; shown = 24; writeState(); readState(); render(); status.scrollIntoView({behavior:'instant', block:'start'}); }); });
    window.addEventListener('popstate', function () { clearTimeout(timer); readState(); render(); });
    async function json(url) {
      var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(url, {headers:{Accept:'application/json'}, signal:controller.signal});
        if (!response.ok) throw new Error('Catalog response ' + response.status);
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    async function load() {
      if (loading) return;
      loading = true; failed = false; done = false; render();
      try {
        for (var page = 1; ; page++) {
          var data = await json(root + 'products.json?limit=100&page=' + page);
          if (!Array.isArray(data.products)) throw new Error('Missing catalog products');
          var added = 0;
          data.products.forEach(function (p) { if (!products.has(p.handle)) added++; products.set(p.handle, normalize(p)); });
          if (page === 1) render();
          if (data.products.length < 100 || (page > 1 && added === 0)) break;
        }
        done = true;
        saveCache();
      } catch (error) { failed = true; }
      loading = false; render();
    }
    retry.addEventListener('click', load);
    readState();
    if (restoreCache()) { done = true; render(); } else { render(); load(); }
  }
  function boot() {
    init(document);
    var main = document.querySelector('main');
    if (main) new MutationObserver(function () { main.querySelectorAll('.wk-rail2:not([data-shopping-ready])').forEach(enhanceRail); }).observe(main, {childList:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { init(document); });
})();

